import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPhpComponent } from './simple-icons-php.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPhpComponent ],
    exports:      [ SimpleIconsPhpComponent ],
    bootstrap:    []
})
export class SimpleIconsPhpModule {}
